<script>
import { toFormattedNumber } from '@/utils/number'

export default {
  props: {
    index: {
      type: Number,
      default: 0
    },

    name: {
      type: String,
      default: ''
    },

    bank: {
      type: String,
      default: ''
    },

    accountNo: {
      type: String,
      default: ''
    },

    amount: {
      type: Number,
      default: 0
    },

    feePercentage: {
      type: Number,
      default: 0
    },

    refNo: {
      type: String,
      default: ''
    },

    showDetail: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    fee() {
      return (this.amount * this.feePercentage) / 100
    },

    total() {
      return this.amount + this.fee
    },

    accountInfo() {
      if (this.bank || this.accountNo) {
        return `${this.bank} ${this.accountNo}`.trim()
      }

      return ''
    }
  },

  render() {
    const renderDetail = () => {
      const renderAmount = () => (
        <el-row type="flex" gutter={16} class={this.$style.detailItem}>
          <el-col span={16}>จำนวน</el-col>
          <el-col span={8}>{toFormattedNumber(this.amount, 2)} บาท</el-col>
        </el-row>
      )

      const renderFee = () => (
        <el-row type="flex" gutter={16} class={this.$style.detailItem}>
          <el-col span={16}>
            ค่าธรรมเนียม {toFormattedNumber(this.feePercentage)}%
          </el-col>
          <el-col span={8}>{toFormattedNumber(this.fee, 2)} บาท</el-col>
        </el-row>
      )

      const renderRef = () => (
        <div class={this.$style.detailItem}>รหัสอ้างอิง {this.refNo}</div>
      )

      return (
        <div class={this.$style.detail}>
          {renderAmount()}
          {renderFee()}
          {renderRef()}
        </div>
      )
    }

    return (
      <div>
        <el-row type="flex" gutter={16} class={this.$style.header}>
          <el-col span={null} style={{ flexBasis: '3em' }}>
            {this.index}.
          </el-col>

          <el-col span={null} style={{ flex: '1' }}>
            <div>
              {this.name}
              {this.accountInfo && (
                <span style={{ fontWeight: 'normal' }}>{this.accountInfo}</span>
              )}
            </div>

            {this.showDetail && renderDetail()}
          </el-col>

          <el-col span={null}>{toFormattedNumber(this.total, 2)} ฿</el-col>
        </el-row>
      </div>
    )
  }
}
</script>

<style lang="scss" module>
.header {
  font-weight: bold;
}

.detail {
  font-size: 0.75rem;
  font-weight: normal;
  margin-top: 0.5em;
}

.detailItem {
  & ~ & {
    margin-top: 0.25em;
  }
}
</style>
